<template>
  <div class="native-skeleton" aria-label="加载中" role="status">
    <span v-for="row in rows" :key="row" />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ rows?: number }>(), { rows: 4 });
</script>

<style scoped>
.native-skeleton {
  display: grid;
  gap: 14px;
}

.native-skeleton span {
  height: 18px;
  border-radius: 5px;
  background: linear-gradient(90deg, #eef1f4 25%, #f7f8f9 50%, #eef1f4 75%);
  background-size: 200% 100%;
  animation: native-skeleton-pulse 1.3s infinite;
}

@keyframes native-skeleton-pulse {
  to { background-position: -200% 0; }
}
</style>
